export default __webpack_public_path__ + "static/media/workplace_img_3.4e6c9422.jpg";